const types = {};

export default function ({type,...args}) {
     return function (Component) {
        types[type] = {
            ...args,
            type,
            Component
        }
    }
}
export const getTypes = () => Object.values(types)
export const getProps = (prop) => getTypes().reduce((s,{[prop]:p}) => ({...s,...p}) ,{})
export const get = (type) => types[type]
